/**
 * @brief   Uebergibt eine Trefferliste (IDs) der globalen Suche an die Ziel-Liste (*-overview),
 *          zu der der Nutzer per "In <Modul> nach '<Suchwert>' suchen" gesprungen ist.
 */
import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {filter, map} from 'rxjs/operators';

export interface GlobalSearchHandoffPayload {
    ids: number[];
    /** Suchbegriff, der zu dieser Trefferliste gefuehrt hat — fuer die Anzeige im Filter-Chip. */
    searchInput: string;
    /** Nach dem Filtern den ersten Treffer rechts oeffnen (Enter in der globalen Suche auf der eigenen Liste, PDEV-1856). */
    openFirst?: boolean;
}

interface PendingIds extends GlobalSearchHandoffPayload {
    entityType: string;
}

@Injectable({
    providedIn: 'root',
})
export class GlobalSearchHandoffService {
    private pending: PendingIds | null = null;
    private readonly handoff$ = new Subject<PendingIds>();

    setPendingIds(entityType: string, ids: number[], searchInput: string, openFirst = false): void {
        this.pending = {entityType, ids, searchInput, openFirst};
        this.handoff$.next({entityType, ids, searchInput, openFirst});
    }

    /** Liefert IDs + Suchbegriff fuer den angegebenen Entitätstyp und loescht sie danach sofort (read-once). */
    consumePendingIds(entityType: string): GlobalSearchHandoffPayload | null {
        if (this.pending?.entityType !== entityType) {
            return null;
        }
        const {ids, searchInput, openFirst} = this.pending;
        this.pending = null;
        return {ids, searchInput, openFirst};
    }

    /** Feuert bei jedem neuen Sprung aus der globalen Suche fuer den angegebenen Entitätstyp. */
    onIdsHandoff(entityType: string): Observable<GlobalSearchHandoffPayload> {
        return this.handoff$.pipe(
            filter((pending) => pending.entityType === entityType),
            map(({ids, searchInput, openFirst}) => ({ids, searchInput, openFirst})),
        );
    }
}
